import { render, staticRenderFns } from "./CommissionSubscriptions.vue?vue&type=template&id=5656011a&scoped=true&lang=pug&"
import script from "./CommissionSubscriptions.vue?vue&type=script&lang=ts&"
export * from "./CommissionSubscriptions.vue?vue&type=script&lang=ts&"
import style0 from "./CommissionSubscriptions.vue?vue&type=style&index=0&id=5656011a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5656011a",
  null
  
)

export default component.exports